import { PreviewPostCard } from './preview-post-card';

import type { Post } from '@/entities/post/post-types';
import { cn } from '@/shared/utils/cn';

interface Props {
  className?: string;
  posts?: Post[];
  isLoading?: boolean;
}

export function PreviewPostList({ className, posts = [], isLoading = false }: Props) {
  if (isLoading) {
    return (
      <div className={cn('flex h-full items-center justify-center', className)}>
        <div className="space-y-3 p-6 text-center">
          <div className="mx-auto flex size-12 animate-pulse items-center justify-center rounded-full bg-zinc-100">
            <div className="size-6 rounded bg-zinc-300" />
          </div>
          <p className="text-base text-zinc-500">Loading posts...</p>
        </div>
      </div>
    );
  }

  // Show posts
  return (
    <div className={cn('flex flex-col', className)}>
      <div className="space-y-2 px-6 pb-6">
        {posts.map((post) => (
          <PreviewPostCard key={post._id} post={post} />
        ))}
        {posts.length === 0 && (
          <div className="py-12 text-center">
            <p className="text-zinc-500">No posts found matching your filter</p>
          </div>
        )}
      </div>
    </div>
  );
}
